import { faSignIn } from "@fortawesome/pro-solid-svg-icons";
import { FunctionComponent, memo } from "react";
import { Button } from "@edgetier/components";
import { ClientLogin } from "@edgetier/client-components";

import logo from "images/colour-light-background.svg";
import headerImage from "images/background-cover-image.jpg";

import { signIn } from "./login.utilities";
import { IProps } from "./login.types";
import "./login.scss";

/**
 * Login button that redirects to AWS Cognito when clicked.
 * @returns Sign-in button.
 */
const Login: FunctionComponent<IProps> = () => {
    return (
        <ClientLogin headerImage={headerImage} logo={logo} title="WatchTower" version={process.env.REACT_APP_VERSION}>
            <Button icon={faSignIn} onClick={signIn}>
                Sign in
            </Button>
        </ClientLogin>
    );
};

export default memo(Login);
